import grow2529DetailsFakeFeatures from '~pricing/experiments/grow_2529_forms/transformers/details/fakeFeatures';
import grow2792DetailsFakeFeatures from '~pricing/experiments/grow_2792_pnp_refresh_v1/transformers/details/groupings/fakeFeatures';

export default [...grow2529DetailsFakeFeatures, ...grow2792DetailsFakeFeatures];
